import type { Bounds } from "@repo/ui";

import { BaseController } from "@repo/baseCloud";

import type { BranchViewModel, MapSettings, PositionViewModel, RetailLocationViewModel } from "../models";
import type { IMapFilter } from "../pages/maps/filters/filterContext";

const controller = "Breadcrumbs";

export class BreadcrumbsController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static GetPositions = <T extends PositionViewModel>(action: string, params: Partial<IMapFilter>) =>
		BreadcrumbsController.Get<T[]>(action, params);

	public static getLiveView(filters: Partial<IMapFilter>) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetLiveView", params);
	}

	public static getGeographicView(bounds: Bounds, filters: Partial<IMapFilter>) {
		const params = {
			...filters,
			...bounds,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetGeographicView", params);
	}

	public static getPositions(filters: Partial<IMapFilter>) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetPositions", {
			...params,
		});
	}

	public static getSales(filters: Partial<IMapFilter>) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetSales", {
			...params,
		});
	}

	public static getLeads(filters: Partial<IMapFilter>) {
		const params = {
			...filters,
			repIds: filters.reps,
		};

		return BreadcrumbsController.GetPositions("GetLeads", {
			...params,
		});
	}

	public static getRetailLocations(
		stateIds?: (number | string)[],
		marketerIds?: (number | string)[],
		assignedUserIds?: (number | string)[],
		officeNumbers?: (number | string)[],
		lastPositions?: string,
		isActive?: boolean,
	) {
		return BreadcrumbsController.GetPositions<RetailLocationViewModel>("GetRetailLocations", {
			stateIds,
			marketerIds,
			assignedUserIds,
			officeNumbers,
			lastPositions,
			isActive,
		});
	}

	public static getOffices(lastPositions?: string, isActive?: boolean) {
		return BreadcrumbsController.GetPositions<BranchViewModel>("GetOffices", {
			lastPositions,
			isActive,
		});
	}

	public static getSettings() {
		return BreadcrumbsController.Get<MapSettings>("GetSettings");
	}
}
